import React, { useEffect, useState } from "react";
import BookingForm from "./bookingForm";
import Card from "./Card";
import Hero from "./Hero";
import QuickSelection from "./QuickSelection";
import Recommended from "./recommended";
import Install from "../PWA/install";

let deferredPrompt;

const Index = () => {
  const [installable, setInstallable] = useState(false);
  const [loading, setLoading] = useState(true);

  const handleInstallClick = () => {
    setInstallable(false);
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the install prompt");
        } else {
          console.log("User dismissed the install prompt");
        }
        deferredPrompt = null;
      });
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      deferredPrompt = e;
      setInstallable(true);
    };

    const handleAppInstalled = () => {};

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    window.addEventListener("appinstalled", handleAppInstalled);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
      window.removeEventListener("appinstalled", handleAppInstalled);
    };
  }, []);

  const handleCloseClick = () => {
    setInstallable(false);
  };

  return (
    <>
    <div className={`mb-20 ${installable ? 'pb-48' : ''}`} style={{ fontFamily: 'Lato, sans-serif' }}>
      <Hero />
      <BookingForm />
      <Recommended />
      </div>

   {installable && (
  <div className="fixed bottom-0 left-0 w-full bg-white shadow-lg px-4 py-3 z-[9999] font-lato">
    <Install
      installable={installable}
      onInstallClick={handleInstallClick}
      onCloseClick={handleCloseClick}
    />
  </div>
)}
      </>
   
  );
};

export default Index;
